// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Loader from "../common/Loader";
// import { FaTimes } from "react-icons/fa";
// import RichTextEditor from "../common/RichTextEditor";

// const EditHomePageModal = ({ isOpen, onClose, content, onContentUpdated }) => {
//   const [heading, setHeading] = useState("");
//   const [subheading, setSubheading] = useState("");
//   const [description, setDescription] = useState("");
//   const [images, setImages] = useState([]);
//   const [keyPoints, setKeyPoints] = useState([{ title: "", description: "" }]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (!content) return;
//     setHeading(content.heading || "");
//     setSubheading(content.subheading || "");
//     setDescription(content.description?.join("\n") || "");
//     setImages(content.images || []);
//     setKeyPoints(content.keyPoints?.length ? content.keyPoints : [{ title: "", description: "" }]);
//   }, [content]);

//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
//     const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);
//     return res.data.secure_url;
//   };

//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
//       setImages([...images, ...urls]);
//       toast.success("Images uploaded successfully");
//     } catch { toast.error("Image upload failed"); }
//     finally { setLoading(false); }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const payload = {
//         heading,
//         subheading,
//         description: description.split("\n").filter(d => d.trim()),
//         images,
//         keyPoints: keyPoints.filter(k => k.title && k.description)
//       };
//       const res = await axios.put(`${process.env.REACT_APP_API_URL}/home/edit-section/${content._id}`, payload);
//       onContentUpdated(res.data.data);
//       // toast.success("Updated successfully");
//       onClose();
//     } catch { toast.error("Failed to update content"); }
//     finally { setLoading(false); }
//   };

//   if (!isOpen) return null;
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
//       <div className="bg-white w-full max-w-3xl p-6 rounded">
//         <div className="flex justify-between items-center w-full"><h2 className="text-xl font-bold mb-4">Edit Home Page Content</h2>
//           <button
//             type="button"
//             onClick={onClose}
//             className=" hover:text-gray-600 "
//           >
//             <FaTimes />
//           </button>
//         </div>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <input type="text" placeholder="Heading" value={heading} onChange={e => setHeading(e.target.value)} className="w-full border px-3 py-2 rounded" required />
//           <input type="text" placeholder="Subheading" value={subheading} onChange={e => setSubheading(e.target.value)} className="w-full border px-3 py-2 rounded" required />
//           <div>
//             <label className="block mb-1 font-medium">Description</label>
//             <RichTextEditor
//               value={description}
//               onChange={(value) => setDescription(value)}
//               placeholder="Enter description..."
//               className="w-full border rounded"
//             />
//           </div>
//           <input type="file" multiple onChange={handleImageUpload} />
//           <div className="flex flex-wrap gap-2">
//             {images.map((img, i) => (
//               <div key={i} className="relative w-20 h-20">
//                 <img src={img} className="w-full h-full object-cover rounded border" />
//                 <button
//                   type="button"
//                   onClick={() => setImages(images.filter((_, index) => index !== i))}
//                   className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
//                 >
//                   ×
//                 </button>
//               </div>
//             ))}
//           </div>

//           {keyPoints.map((kp, i) => (
//             <div key={i} className="flex flex-col gap-2 mb-2">
//               <input
//                 type="text"
//                 placeholder="Title"
//                 value={kp.title}
//                 onChange={(e) => {
//                   const temp = [...keyPoints];
//                   temp[i].title = e.target.value;
//                   setKeyPoints(temp);
//                 }}
//                 className="border px-2 py-1 rounded"
//               />
//               <RichTextEditor
//                 value={kp.description}
//                 onChange={(value) => {
//                   const temp = [...keyPoints];
//                   temp[i].description = value;
//                   setKeyPoints(temp);
//                 }}
//                 placeholder="Enter key point description..."
//                 className="border rounded"
//               />
//             </div>
//           ))}

//           <button type="button" onClick={() => setKeyPoints([...keyPoints, { title: "", description: "" }])} className="bg-blue-500 text-white px-2 py-1 rounded text-sm">+ Add Key Point</button>

//           <div className="flex justify-end gap-3 pt-2">
//             <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
//             <button type="submit" disabled={loading} className="bg-orange-500 px-4 py-2 text-white rounded">{loading ? <Loader /> : "Update Content"}</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditHomePageModal;


import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../common/Loader";
import { FaTimes } from "react-icons/fa";
import RichTextEditor from "../common/RichTextEditor";

const EditHomePageModal = ({ isOpen, onClose, content, onContentUpdated }) => {
  const [heading, setHeading] = useState("");
  const [subheading, setSubheading] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [keyPoints, setKeyPoints] = useState([{ title: "", description: "" }]);
  
  // SEO Fields
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!content) return;
    setHeading(content.heading || "");
    setSubheading(content.subheading || "");
    setDescription(content.description?.join("\n") || "");
    setImages(content.images || []);
    setKeyPoints(content.keyPoints?.length ? content.keyPoints : [{ title: "", description: "" }]);
    
    // SEO fields
    setMetaTitle(content.metaTitle || "");
    setMetaDescription(content.metaDescription || "");
    setMetaKeywords(content.metaKeywords || "");
    setCanonicalUrl(content.canonicalUrl || "");
  }, [content]);

  // Auto-generate meta title when heading changes
  useEffect(() => {
    if (heading && !metaTitle) {
      setMetaTitle(`${heading} | BBSR Services`);
    }
  }, [heading]);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
    const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
      setImages([...images, ...urls]);
      toast.success("Images uploaded successfully");
    } catch { toast.error("Image upload failed"); }
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        heading,
        subheading,
        description: description.split("\n").filter(d => d.trim()),
        images,
        keyPoints: keyPoints.filter(k => k.title && k.description),
        metaTitle: metaTitle || `${heading} | BBSR Services`,
        metaDescription: metaDescription || description.split("\n").filter(d => d.trim())[0]?.substring(0, 160) || '',
        metaKeywords: metaKeywords || `${heading}, BBSR Services, business solutions`,
        canonicalUrl: canonicalUrl || 'https://www.bbsrservices.co.in/'
      };
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/home/edit-section/${content._id}`, payload);
      onContentUpdated(res.data.data);
      toast.success("Updated successfully");
      onClose();
    } catch { toast.error("Failed to update content"); }
    finally { setLoading(false); }
  };

  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
      <div className="bg-white w-full max-w-3xl p-6 rounded">
        <div className="flex justify-between items-center w-full">
          <h2 className="text-xl font-bold mb-4">Edit Home Page Content</h2>
          <button
            type="button"
            onClick={onClose}
            className="hover:text-gray-600"
          >
            <FaTimes />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Basic Content */}
          <input 
            type="text" 
            placeholder="Heading" 
            value={heading} 
            onChange={e => setHeading(e.target.value)} 
            className="w-full border px-3 py-2 rounded" 
            required 
          />
          <input 
            type="text" 
            placeholder="Subheading" 
            value={subheading} 
            onChange={e => setSubheading(e.target.value)} 
            className="w-full border px-3 py-2 rounded" 
            required 
          />
          
          <div>
            <label className="block mb-1 font-medium">Description</label>
            <RichTextEditor
              value={description}
              onChange={(value) => setDescription(value)}
              placeholder="Enter description..."
              className="w-full border rounded"
            />
          </div>
          
          <input type="file" multiple onChange={handleImageUpload} />
          <div className="flex flex-wrap gap-2">
            {images.map((img, i) => (
              <div key={i} className="relative w-20 h-20">
                <img src={img} className="w-full h-full object-cover rounded border" />
                <button
                  type="button"
                  onClick={() => setImages(images.filter((_, index) => index !== i))}
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Key Points */}
          {keyPoints.map((kp, i) => (
            <div key={i} className="flex flex-col gap-2 mb-2">
              <input
                type="text"
                placeholder="Key Point Title"
                value={kp.title}
                onChange={(e) => {
                  const temp = [...keyPoints];
                  temp[i].title = e.target.value;
                  setKeyPoints(temp);
                }}
                className="border px-2 py-1 rounded"
              />
              <RichTextEditor
                value={kp.description}
                onChange={(value) => {
                  const temp = [...keyPoints];
                  temp[i].description = value;
                  setKeyPoints(temp);
                }}
                placeholder="Enter key point description..."
                className="border rounded"
              />
            </div>
          ))}

          <button 
            type="button" 
            onClick={() => setKeyPoints([...keyPoints, { title: "", description: "" }])} 
            className="bg-blue-500 text-white px-2 py-1 rounded text-sm"
          >
            + Add Key Point
          </button>

          {/* SEO Section */}
          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold text-blue-600 mb-3">SEO Settings</h3>
            
            <div className="space-y-3">
              <input
                type="text"
                placeholder="Meta Title (SEO)"
                value={metaTitle}
                onChange={e => setMetaTitle(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">{metaTitle?.length || 0}/60 characters</p>
              
              <textarea
                placeholder="Meta Description (SEO)"
                value={metaDescription}
                onChange={e => setMetaDescription(e.target.value)}
                rows="3"
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">{metaDescription?.length || 0}/160 characters</p>
              
              <input
                type="text"
                placeholder="Meta Keywords (SEO)"
                value={metaKeywords}
                onChange={e => setMetaKeywords(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">Separate keywords with commas</p>
              
              <input
                type="url"
                placeholder="Canonical URL"
                value={canonicalUrl}
                onChange={e => setCanonicalUrl(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button type="submit" disabled={loading} className="bg-orange-500 px-4 py-2 text-white rounded">
              {loading ? <Loader /> : "Update Content"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditHomePageModal;